import { render } from "./PlanoContaModal.vue?vue&type=template&id=6dbda029&scoped=true&ts=true"
import script from "./PlanoContaModal.vue?vue&type=script&lang=ts"
export * from "./PlanoContaModal.vue?vue&type=script&lang=ts"

import "./PlanoContaModal.vue?vue&type=style&index=0&id=6dbda029&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dbda029"]])

export default __exports__